module.exports = __webpack_public_path__ + "static/img/wx-code.5a19de6.png";


//////////////////
// WEBPACK FOOTER
// ./static/home/wx-code.png
// module id = N85+
// module chunks = 1